import { useRouter } from 'next/router';
import { OrderSaleTab } from '@components/orders-sales/type';

export type QueryTab = OrderSaleTab | 'ShippingReminder';

export const ROUTER_QUERY_KEY = {
  order: '1',
  sale: '2',
  shippingReminder: '3',
};

const QUERY_MAP = new Map<string, QueryTab>([
  [ROUTER_QUERY_KEY.order, 'Order'],
  [ROUTER_QUERY_KEY.sale, 'Sale'],
  [ROUTER_QUERY_KEY.shippingReminder, 'ShippingReminder'],
]);

export default function useQueryTab(): {
  query: QueryTab | null;
  tab: OrderSaleTab;
} {
  const {
    query: { section },
  } = useRouter();

  const query = QUERY_MAP.get(Array.isArray(section) ? section[0] : section);

  return { query, tab: query === 'ShippingReminder' ? 'Sale' : query };
}
